var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutfitNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1214.8,1132.8L990.6,585.9c-2.5-6-8.3-9.9-14.8-9.9H936c-8.8,0-16,7.2-16,16v32c0,8.8,7.2,16,16,16h7.6 L996,768h-60c-8.8,0-16,7.2-16,16v32c0,8.8,7.2,16,16,16h86.3l113.1,275.8c-107.7,29.4-218.8,44.3-330.4,44.2 c-111.9,0.1-223.3-14.9-331.3-44.4l76.1-200.7c1.6-4.1-0.5-8.8-4.6-10.3c-0.9-0.3-1.9-0.5-2.8-0.5h-45.8c-6.7,0-12.6,4.1-15,10.3 l-86.1,227c-3.1,8.3,1,17.5,9.3,20.6c0.3,0.1,0.7,0.2,1,0.4l16.4,5c124.1,37.7,253.1,56.8,382.8,56.7 c129.7,0.1,258.7-19,382.8-56.7l16.8-5.1c8.5-2.6,13.2-11.5,10.7-20C1215.2,1133.7,1215,1133.2,1214.8,1132.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M858,66c-2.3-1.3-5-2-7.7-2H694.1c0,70.6-57.5,128-128.1,128S437.9,134.6,437.9,64H281.7 c-2.7,0-5.3,0.7-7.7,2L84.3,169.4c-6,3.3-9.2,9.9-8.1,16.6l36.1,216.6c1.3,7.7,8,13.4,15.8,13.4h149.7v400c0,8.8,7.2,16,16,16 h546.5c8.8,0,16-7.2,16-16V416h147.6c7.8,0,14.5-5.7,15.8-13.4l36.1-216.6c1.1-6.7-2.1-13.4-8.1-16.7L858,66z M963.2,352h-173v416 H344V352H168.8L145,209.2L294,128h90.9c26.4,74.5,97.6,128,181.1,128s154.7-53.5,181.2-128H838l149,81.2L963.2,352z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfitNormal);
export default __webpack_public_path__ + "static/media/outfit_normal.9ba5c36b46d1f04f72f8f7d18b8d56ba.svg";
export { ForwardRef as ReactComponent };